import { Component, Input } from '@angular/core';
import { PropertiesSettings } from "../../../../core/configuration/properties-settings";

@Component({
    selector: '[patologia_entity_view]',
  templateUrl: 'patologia-entity-view.component.html',
})

export class PatologiaEntityViewComponent {
  readonly PROPERTIES_SETTINGS = PropertiesSettings;
  @Input()
  element;
}
